import {FullScreenLoader} from "@/components/FullScreenLoader.jsx";
import {useAcceptInvitationMutation} from "@/features/users/api.js";
import {Navigate, useNavigate, useParams} from "react-router-dom";
import {useEffect} from "react";
import {Box, Typography} from "@mui/joy";
import {FullScreenCentered} from "@/components/FullScreenCentered.jsx";
import {useGetProfileQuery} from "@/features/onboarding/api.js";

export function AcceptInvitationPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [acceptInvitation, result] = useAcceptInvitationMutation();
  const {error: profileError, isLoading} = useGetProfileQuery();

  useEffect(() => {
    if (isLoading) return;
    if (!profileError) {
      acceptInvitation({id});
    } else {
      navigate('/onboarding/create-profile');
    }
  }, [isLoading, profileError]);

  if (result?.isError) {
    return <InvalidInvitation/>;
  } else if (result?.isSuccess) {
    return <Navigate to={`/h/${result.data.data.household_id}`} />;
  }

  return (
    <FullScreenLoader />
  );
}

function InvalidInvitation() {
  return (
    <FullScreenCentered>
      <Box>
        <Typography component="h1" level="h2" sx={{ textAlign: 'center', mb: 2 }}>Invitation link is invalid</Typography>
        <Typography level="body-md" sx={{ textAlign: 'center' }}>
          The invitation link you are trying to use doesn&apos;t exist or has expired. <br />
          Try requesting the invitation from the administrator of the organization again.
        </Typography>
      </Box>
    </FullScreenCentered>
  );
}